<template>
  <div
    :class="[
      'form-item-box',
      { 'change-form-item-box-style': item.changeformItemBoxStyle },
      { 'come-from-PC-acoount': item.comeFormUserInfo },
    ]"
  >
    <div
      v-for="subitem in item.children"
      :key="subitem.field"
      :class="['form-item-content', { 'come-from-PC-acoount-2': item.comeFormUserInfo }]"
    >
      <div class="form-item-label">
        <label :for="item.field" class="form-item-subTitle">{{ i18n.t(subitem.label) }}</label>
        <span v-if="subitem.subLabel" class="sub-label">{{ i18n.t(subitem.subLabel) }}</span>
      </div>
      <div class="input-wrapper">
        <input
          :id="subitem.field"
          :maxlength="subitem.maxlength"
          :minlength="subitem.minlength"
          :placeholder="subitem.placeholder"
          :class="[
            'form-item-input',
            'fs-mask',
            { 'form-item-error-border': subitem.errorShow },
            { 'come-from-PC-acoount-3': item.comeFormUserInfo },
          ]"
          :disabled="subitem.disabled"
          type="text"
          aria-required="true"
          autocomplete="off"
          v-model="itemValue[subitem.field]"
          @blur="handleValueSend($event, subitem.field)"
          @change="handleValueChange($event, subitem.field)"
        />
        <img
          v-if="subitem.comeForm === 'UserInfo'"
          class="eye"
          :src="subitem.on ? eyeOn : eyeOff"
          @click="clickEye(subitem)"
          alt=""
        />
      </div>
      <p v-show="subitem.errorShow" class="form-item-error" :key="subitem.errorMsg">
        {{ subitem.errorMsg }}
      </p>
    </div>
  </div>
</template>

<script>
  import i18n from '@/i18n';
  import { showFirstChar } from '@/utils';

  export default {
    name: 'formName',
    props: {
      item: {
        type: Object,
        default: () => {},
      },
      itemFormValue: {
        type: Object,
        default: () => {},
      },
    },

    mounted() {
      if (this.itemFormValue) {
        const isItem = Object.keys(this.itemFormValue);
        if (isItem?.length) {
          this.itemValue = { ...this.itemValue, ...this.itemFormValue };
        }
      }
      this.itemValue.lname = this.itemValue.lname && showFirstChar(this.itemValue.lname);
      this.itemValue.fname = this.itemValue.fname && showFirstChar(this.itemValue.fname);
      this.changeName.lname = this.itemValue.lname && showFirstChar(this.itemValue.lname);
      this.changeName.fname = this.itemValue.lname && showFirstChar(this.itemValue.fname);
    },

    data() {
      return {
        i18n,
        changeName: {
          lname: '',
          fname: '',
        },
        eyeOn: require('@/assets/images/icon-feather-eye-on.svg'),
        eyeOff: require('@/assets/images/icon-feather-eye-off.svg'),
        itemValue: {},
      };
    },

    methods: {
      // 失去焦点后发送给父组件的数据
      handleValueSend(e, field) {
        this.$emit('value', this.itemValue, field);
      },
      handleValueChange(e, field) {
        this.$emit('value', this.itemValue, field);
      },
      clickEye(item) {
        item.on = !item.on;
        if (!item.on) {
          return (this.itemValue[item.field] = this.changeName[item.field]);
        }
        return (this.itemValue[item.field] = this.itemFormValue[item.field]);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import './index';
  @import './mobile';
</style>
